export const RIBBON_GROUPS = [
    {
        id: "file",
        title: "ribbon-group-file",
        items: [
            {kind: "button", large: true, icon: "mi mi:upload_file", title: "word-import-button", cmd: {type: "word"}},
            {kind: "button", large: true, icon: "mi mi:videocam", title: "upload-content", cmd: {type: "upload", kind: "video"}},
            {kind: "button", feature: true, large: true, icon: "mi mi:auto_awesome", title: "ai-generate-content", cmd: {type: "ai"}},
        ],
    },
    {
        id: "style",
        title: "ribbon-group-style",
        grid: {columns: 4},
        items: [
            {kind: "button", icon: "mi mi:title", title: "post-editor-normal-text", cmd: {type: "heading", arg: 0}},
            {kind: "button", icon: "mi mi:format_h1", title: "post-editor-heading-one", cmd: {type: "heading", arg: 1}},
            {kind: "button", icon: "mi mi:format_h2", title: "post-editor-heading-two", cmd: {type: "heading", arg: 2}},
            {kind: "button", icon: "mi mi:format_h3", title: "post-editor-heading-three", cmd: {type: "heading", arg: 3}},
            {kind: "button", icon: "mi mi:format_h4", title: "post-editor-heading-four", cmd: {type: "heading", arg: 4}},
            {kind: "button", icon: "mi mi:format_h5", title: "post-editor-heading-five", cmd: {type: "heading", arg: 5}},
            {kind: "button", icon: "mi mi:format_h6", title: "post-editor-heading-six", cmd: {type: "heading", arg: 6}},
        ],
    },
    {
        id: "text",
        title: "ribbon-group-text",
        items: [
            {kind: "button", icon: "mi mi:format_bold", title: "post-editor-bold", activeKey: "bold",
                cmd: {type: "wrap", before: "**", after: "**", placeholder: "text"}},
            {kind: "button", icon: "mi mi:format_italic", title: "post-editor-italic", activeKey: "italic",
                cmd: {type: "wrap", before: "*", after: "*", placeholder: "text"}},
            {kind: "button", icon: "mi mi:format_strikethrough", title: "post-editor-strikethrough", activeKey: "strike",
                cmd: {type: "wrap", before: "~~", after: "~~", placeholder: "text"}},
            {kind: "button", icon: "mi mi:code", title: "post-editor-inline-code", activeKey: "code",
                cmd: {type: "wrap", before: "`", after: "`", placeholder: "code"}},
        ],
    },
    {
        id: "paragraph",
        title: "ribbon-group-paragraph",
        grid: {columns: 3},
        items: [
            {kind: "button", icon: "mi mi:format_list_bulleted", title: "post-editor-bullet-list",
                cmd: {type: "line", arg: "- "}},
            {kind: "button", icon: "mi mi:format_list_numbered", title: "post-editor-ordered-list",
                cmd: {type: "line", arg: "1. "}},
            {kind: "button", icon: "mi mi:format_quote", title: "post-editor-quote",
                cmd: {type: "line", arg: "> "}},
            {kind: "button", icon: "mi mi:checklist", title: "post-editor-task-list",
                cmd: {type: "line", arg: "- [ ] "}},
            {kind: "button", icon: "mi mi:format_indent_increase", title: "post-editor-indent",
                cmd: {type: "indent"}},
            {kind: "button", icon: "mi mi:format_indent_decrease", title: "post-editor-outdent",
                cmd: {type: "outdent"}},
        ],
    },
    {
        id: "insert",
        title: "ribbon-group-insert",
        grid: {columns: 3},
        items: [
            {kind: "button", icon: "mi mi:link", title: "post-editor-link",
                cmd: {type: "wrap", before: "[", after: "](url)", placeholder: "text"}},
            {kind: "button", icon: "mi mi:image", title: "post-editor-image",
                cmd: {type: "upload", kind: "image"}},
            {kind: "button", icon: "mi mi:table", title: "post-editor-table",
                cmd: {type: "insert", value: "| col1 | col2 | col3 |\n| --- | --- | --- |\n|   |   |   |\n"}},
            {kind: "button", icon: "mi mi:horizontal_rule", title: "post-editor-horizontal-rule",
                cmd: {type: "insert", value: "\n---\n"}},
            {kind: "button", icon: "mi mi:data_object", title: "post-editor-code-block",
                cmd: {type: "wrap", before: "\n```\n", after: "\n```\n", placeholder: "code"}},
        ],
    },
];